import React from 'react'

const Loading = () => {
  return (
    <div className="w-full flex justify-center items-center py-20">
    <div className="text-white text-xl font-semibold animate-pulse">
        Loading...
    </div>
  </div>
  )
}

export default Loading